<template lang="pug">
v-card(class="pa-4")
    div(v-if="!sent")
        div(class="close-icon")
          v-btn(icon @click="closeDialog") 
            v-icon mdi-close
        v-card-title Ask us anything
        v-card-subtitle Now that you know how much you could save, tell us more about what your ideal EV looks like
        v-form(v-model="valid" ref="form" :lazy-validation="false")
          v-row
              v-col(cols=12)
                  v-textarea(v-model="message" label="What do we need to know?" required)
          v-row
              v-col(cols=6)
                  v-text-field(v-model="firstName" label="First name*" required :rules="[v => !!v || 'First name is required']")
              v-col(cols=6)
                  v-text-field(v-model="lastName" label="Last name*" required :rules="[v => !!v || 'Last name is required']")
          v-row
              v-col(cols=12)
                  v-text-field(v-model="email" label="Email*" :rules="emailRules" required)
          v-row
              v-col(cols=12)
                  v-text-field(v-model="phoneNumber" label="Phone number" required)
          v-row
              v-col(cols=12)
                  v-checkbox(v-model="getPDF" label="Send me an email with a link so I can access this information in the future.")
          v-row(justify="center")
              v-col(cols=12 lg=4)
                  v-btn(color="primary" @click="validate"  block ) Find my EV
    div(v-if="sent")
        div(class="close-icon")
          v-btn(icon @click="closeDialog") 
            v-icon mdi-close
        v-card-title Thanks for reaching out to us, we'll be in touch soon!
        v-card-text In the mean time, check out the Power Trip EV Guide for quick answers to the common questions people have about EVs in New Zealand
        v-row(justify="center")
            v-col(cols=12 lg=4)
                v-btn(color="primary" @click="visitGuide"  block ) GUIDE TO EVs IN NZ
    vue-html2pdf(  :show-layout="false"
        :enable-download="true"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        filename="PowerSellCarRecommendataion"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="800px"
        ref="html2Pdf")
        section(slot="pdf-content")
          section(class="pdf-item")
            CarPDF(:carList="carList", :selectedIndex="selectedIndex", :trips="trips", :bubble="bubble")
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import CarPDF from "./CarPDF.vue";
import PowerTrip from '../services/api/PowerTrip';
export default {
  components: {
    VueHtml2pdf,
 CarPDF
  },
  props: ["carList", "selectedIndex", "trips", "bubble"],
  data() {
    return {
      message: "",
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      getPDF: true,
      sent: false,
      valid: false,
            emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ]
    };
  },
  methods: {
    validate() {
      this.$refs.form.validate();
      if (this.valid) {

        let car = this.carList[this.selectedIndex]
      let emailData = {
        car: {
          name: car.Name,
          link: car.ListingLink
        },
        message: this.message,
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        phoneNumber: this.phoneNumber,
        state:  this.logState(),
        dealer: this.$dealer.serviceID
      }
      if (this.getPDF == true) {
        emailData.returnEmail = true
      }

      PowerTrip.sendEmail(emailData);
      console.log(JSON.stringify(emailData));
     
      //this.generatePDF()
      
      this.sent = true;
}
    },
    generatePDF() {
      this.$refs.html2Pdf.generatePdf()
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    visitGuide() {
        window.open("https://powertrip.earth/","_blank");
    }
    ,
    closeDialog() {
      this.$emit("close");
    }
  }
};
</script>
<style scoped>
.close-icon {
  position: absolute;
  right: 0;
  top:0;
  margin-bottom:10px;
}
.v-card__title {
  word-break: normal;
}
.vue-html2pdf {
  font-size:2em;
}
</style>
